/*
 * Constants 
 */
module.exports = {
  maxQuantity: 999999,

  qtyChangeEvt: 'rs.product.qty.changed',

  hlBreakPriceChangeEvt: 'rs.product.hl.price.changed',

  cartAddedEvt: 'rs.cart.added',

  popupShowEvt: 'rs.product.popup.show',

  popupShownEvt: 'rs.product.popup.shown',

  popupHideEvt: 'rs.product.popup.hide',

  qtyPlaceHolder: '##QTY##',

  modalTemplateUrl: '/modalTpl.jsp',

  addToCartUrl: '/services/shoppingBasket/lineItems/{articleId}/{quantity}',

  checkStockLevelUrl: '/services/product/getstock/{articleId}/{productId}/{quantity}',

  basketUrl: (typeof(params) !== "undefined") ? params.basketUrl : null,

  getPartsListUrl: '/services/product/partslist',

  savePartsListUrl: '/services/product/partslist/{partsListName}/{articleId}/{quantity}'
};



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/commons/constants.js
// module id = 8
// module chunks = 2 4 6 7